<template>
    <edit-view-base :filter="filter" :has-card-view="false" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Honey Type', apiMethod: 'HoneyTypes', form: () => import('../forms/HoneyTypeForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                    { title: 'Blend Honey Type', apiMethod: 'BlendHoneyTypes', parentForeignKey: 'honeyTypeId', form: () => import('../forms/BlendHoneyTypeForm'), items: [], filter: {}, dialog: false, isVisible: true },
                    { title: 'Sampling', apiMethod: 'Samplings', parentForeignKey: 'honeyTypeId', form: () => import('../forms/SamplingForm'), items: [], filter: {}, dialog: false, isVisible: true },
                ],
                tabs: [
                    { text: 'Blends', value: 'honeyTypeId', isCard: true, table: () => import('../tables/BlendHoneyTypesTable') },
                    { text: 'Samplings', value: 'honeyTypeId', isCard: true, table: () => import('../tables/SamplingsTable') },
                ],
                mainForm: () => import('../forms/HoneyTypeForm'),
                claimName: 'HoneyTypes',
                apiMethod: 'HoneyTypes',
            }
        }
    };
</script>
